module.exports = __webpack_public_path__ + "img/materialM.ef518cd9.png";